import "jquery";
import * as ko from "knockout";
import { TermsApi } from "../apis/TermsApi"
import { TermsViewModel } from "../ViewModels/TermsViewModel"; 

export class Terms {
    private termsApi: TermsApi; 
    private termsViewModel: TermsViewModel; 
    private $termsDiv: JQuery; 

    constructor() {
        this.termsApi = TermsApi.getInstance();
        this.termsViewModel = new TermsViewModel();

        this.$termsDiv = $("#acceptTermsDiv");

        if (this.$termsDiv[0]) {
            ko.applyBindings(this.termsViewModel, this.$termsDiv[0]);
        }
    }

    init(): void {
        this.termsApi.getAccpetedTerms().then((res) => {
            this.termsViewModel.showTerms(res); 
        });
    }

    private setAcceptedTerms(): void {
        this.termsApi.postAcceptedTerm().then((res) => {
        }); 
    }

}